export const FirebaseConfig = {
	"projectId": "safedrive-33ccf",
	"appId": "1:345556656052:web:d89bd8565fbe9c829d1ce1",
	"databaseURL": "https://safedrive-33ccf-default-rtdb.firebaseio.com",
	"storageBucket": "safedrive-33ccf.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyB6dJyQiL8Sv1JJNovVGEbSKFMElC2fCNw",
	"authDomain": "safedrive-33ccf.firebaseapp.com",
	"messagingSenderId": "345556656052",
	"measurementId": "G-NRHVZ6L7BE",
	"projectNumber": "345556656052",
	"version": "2"
};